import React, { createContext, useState,useEffect} from "react";
import { SOADefault } from "./Data";

export const DataContext = createContext();

export const DataProvier = ({ children }) => {

    const [SOA, setSOA] = useState({ ...SOADefault });

    const changeHandler = (event) => {
        setSOA({ ...SOA, [event.target.name]: event.target.value });
    };

    useEffect(() => {
        setSOA({
            ...SOA,
            'setTarificacion': setTarificacion,
            'setCatalogos': setCatalogos,
            'tarificacionChangeHandler': tarificacionChangeHandler,
            init:true
        });
        
    }, [SOA.init]);

    const setTarificacion = (obj) => setSOA(prev => { return { ...prev, tarificacion: {...prev.tarificacion, ...obj } };    });
    const setCatalogos = (obj) => setSOA(prev => { return { ...prev, catalogos: {...prev.catalogos, ...obj } };});
    const tarificacionChangeHandler = event => {
        setSOA({ [event.target.name]: event.target.value });
    }

    return(
        <DataContext.Provider value ={{SOA, setSOA, changeHandler}}>
            {children}
        </DataContext.Provider>
    );
}